// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:host {
  display: inline-block;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  position: relative;
}

.date-picker-container {
  position: relative;
}

.date-input {
  background: white;
  border: 1px solid #CCDCE4 !important;
  border-radius: 16px;
  padding: 8px 10px 8px 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  min-width: 240px;
  height: 52px;
}

.date-input:hover {
  border-color: #0080ff;
}

.date-text {
  font-size: 16px;
  font-weight: 600;
  /*color: #293050;*/
  color: #525252;
  white-space: nowrap;
  flex: 1;
  user-select: none;
}

.chevron-icon {
  width: 20px;
  height: 20px;
  transition: transform 0.2s;
}

.chevron-icon.open {
  transform: rotate(180deg);
}

.popup {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 16px 32px 0px rgba(23, 37, 76, 0.12);
  display: none;
  z-index: 1000;
  overflow: hidden;
}

.popup.open {
  display: flex;
}

.sidebar {
  border-right: 1px solid #e9ebef;
  padding: 16px 24px 16px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 150px;
}

.quick-option {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
  color: #293050;
  transition: background 0.2s;
}

.quick-option:hover {
  background: #f3f3f5;
}

.reset-btn {
  background: transparent;
  border: none;
  color: #0080ff;
  font-size: 16px;
  font-weight: 600;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 8px;
  margin-top: 8px;
}

.reset-btn:hover {
  background: #f3f3f5;
}

.calendar {
  padding: 16px;
  width: 284px;
}

.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.month-year {
  font-size: 16px;
  font-weight: 600;
  color: #293050;
  flex: 1;
  padding-left: 8px;
}

.nav-buttons {
  display: flex;
  gap: 0;
}

.nav-btn {
  background: transparent;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.nav-btn:hover {
  background: #f3f3f5;
}

.weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 8px;
}

.weekday {
  text-align: center;
  font-size: 16px;
  color: #7b8199;
  padding: 8px;
}

.days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.day-cell {
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.day-content {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  font-size: 16px;
  transition: all 0.2s;
  position: relative;
  z-index: 2;
}

.day-cell.current-month .day-content {
  color: #293050;
}

.day-cell.other-month .day-content {
  color: rgba(24, 30, 48, 0.32);
}

.day-cell.weekend .day-content {
  color: #7b8199;
}

.day-cell.today .day-content {
  color: #0080ff;
}

.day-cell:hover .day-content {
  background: #f3f3f5;
}

.day-cell.selected .day-content {
  background: #0080ff;
  color: white;
  font-weight: 600;
}

.day-cell.in-range {
  background: #d9ecff;
}

.day-cell.range-start {
  background: #d9ecff;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}

.day-cell.range-end {
  background: #d9ecff;
  border-top-right-radius: 18px;
  border-bottom-right-radius: 18px;
}

.day-cell.range-start.range-end {
  background: transparent;
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/date-range-picker.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,+EAA+E;EAC/E,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,MAAM;AACR;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:host {\n  display: inline-block;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  position: relative;\n}\n\n.date-picker-container {\n  position: relative;\n}\n\n.date-input {\n  background: white;\n  border: 1px solid #CCDCE4 !important;\n  border-radius: 16px;\n  padding: 8px 10px 8px 16px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  min-width: 240px;\n  height: 52px;\n}\n\n.date-input:hover {\n  border-color: #0080ff;\n}\n\n.date-text {\n  font-size: 16px;\n  font-weight: 600;\n  /*color: #293050;*/\n  color: #525252;\n  white-space: nowrap;\n  flex: 1;\n  user-select: none;\n}\n\n.chevron-icon {\n  width: 20px;\n  height: 20px;\n  transition: transform 0.2s;\n}\n\n.chevron-icon.open {\n  transform: rotate(180deg);\n}\n\n.popup {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0px 16px 32px 0px rgba(23, 37, 76, 0.12);\n  display: none;\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.popup.open {\n  display: flex;\n}\n\n.sidebar {\n  border-right: 1px solid #e9ebef;\n  padding: 16px 24px 16px 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-width: 150px;\n}\n\n.quick-option {\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #293050;\n  transition: background 0.2s;\n}\n\n.quick-option:hover {\n  background: #f3f3f5;\n}\n\n.reset-btn {\n  background: transparent;\n  border: none;\n  color: #0080ff;\n  font-size: 16px;\n  font-weight: 600;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 8px;\n  margin-top: 8px;\n}\n\n.reset-btn:hover {\n  background: #f3f3f5;\n}\n\n.calendar {\n  padding: 16px;\n  width: 284px;\n}\n\n.calendar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.month-year {\n  font-size: 16px;\n  font-weight: 600;\n  color: #293050;\n  flex: 1;\n  padding-left: 8px;\n}\n\n.nav-buttons {\n  display: flex;\n  gap: 0;\n}\n\n.nav-btn {\n  background: transparent;\n  border: none;\n  width: 36px;\n  height: 36px;\n  border-radius: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.nav-btn:hover {\n  background: #f3f3f5;\n}\n\n.weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin-bottom: 8px;\n}\n\n.weekday {\n  text-align: center;\n  font-size: 16px;\n  color: #7b8199;\n  padding: 8px;\n}\n\n.days-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n}\n\n.day-cell {\n  aspect-ratio: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n}\n\n.day-content {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  font-size: 16px;\n  transition: all 0.2s;\n  position: relative;\n  z-index: 2;\n}\n\n.day-cell.current-month .day-content {\n  color: #293050;\n}\n\n.day-cell.other-month .day-content {\n  color: rgba(24, 30, 48, 0.32);\n}\n\n.day-cell.weekend .day-content {\n  color: #7b8199;\n}\n\n.day-cell.today .day-content {\n  color: #0080ff;\n}\n\n.day-cell:hover .day-content {\n  background: #f3f3f5;\n}\n\n.day-cell.selected .day-content {\n  background: #0080ff;\n  color: white;\n  font-weight: 600;\n}\n\n.day-cell.in-range {\n  background: #d9ecff;\n}\n\n.day-cell.range-start {\n  background: #d9ecff;\n  border-top-left-radius: 18px;\n  border-bottom-left-radius: 18px;\n}\n\n.day-cell.range-end {\n  background: #d9ecff;\n  border-top-right-radius: 18px;\n  border-bottom-right-radius: 18px;\n}\n\n.day-cell.range-start.range-end {\n  background: transparent;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
